import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'temp-empty-table',
  template: `
    <div class="no-results">
      <div class="no-results__icon">
        <i class="pi pi-filter-slash"></i>
      </div>
      {{ 'table.noData' | translate }}
    </div>
  `,
  styles: [
    `
      .no-results {
        display: flex;
        align-items: center;
        color: #525252;
        justify-content: center;
        margin: 0.25rem;
      }

      .no-results__icon i {
        margin-right: 0.5rem;
      }
    `,
  ],
  imports: [TranslateModule],
  standalone: true,
})
export class EmptyTableTemplate {}
